import { parsePhoneNumber } from 'libphonenumber-js';

import { getDate } from '../../../../../../utils/dates';
import { getSelectedOption } from '../../../../../../utils/selectFormat';
import {
  AdminAccountForm,
  IdentificationQuery,
  SearchAdminAccount,
} from '../types';

export const adminAccountAdapter = (
  data: SearchAdminAccount,
  query: IdentificationQuery | null,
  options: { countryOptions: any; roleOptions: any },
): AdminAccountForm => {
  const parsedPhone = data?.Account_phone
    ? parsePhoneNumber(data.Account_phone, 'CL')
    : null;

  return {
    id: data.Account_id,
    identificationTypeId:
      data.Account_identificationTypeId ?? query?.identificationTypeId ?? '',
    identificationTypeName: data.Account_identificationTypeName ?? '',
    identification: data.Account_identification ?? query?.identification ?? '',
    countryId: data.Country_id ?? query?.countryId ?? undefined,
    country: data.Country_id
      ? getSelectedOption(data.Country_id, options.countryOptions)
      : query?.countryId
      ? getSelectedOption(query.countryId, options.countryOptions)
      : undefined,
    names: data.Account_name,
    lastnamePather: data.Account_paternalLastName,
    lastnameMother: data.Account_maternalLastName,
    email: data.Account_email ?? '',
    personalEmail: data.Account_personalEmail ?? '',
    phone: parsedPhone?.isValid() ? parsedPhone.formatInternational() : '',
    birthdate: data.Account_birthday
      ? getDate(data.Account_birthday)
      : undefined,
    nationality: data.Nationality_id
      ? getSelectedOption(data.Nationality_id, options.countryOptions)
      : undefined,
    role: data.Role_id
      ? getSelectedOption(data.Role_id, options.roleOptions)
      : undefined,
    teacherId: data.Account_teacherId,
    studentId: data.Account_studentId,
    isActive: data.Account_isActive,
  };
};

export const adminAccountEmptyAdapter = (
  query: IdentificationQuery | null,
  countryOptions: any,
): AdminAccountForm => ({
  id: undefined,
  identificationTypeId: query?.identificationTypeId ?? '',
  identificationTypeName: '',
  identification: query?.identification ?? '',
  countryId: query?.countryId,
  country: query?.countryId
    ? getSelectedOption(query.countryId, countryOptions)
    : undefined,
  names: '',
  lastnamePather: '',
  lastnameMother: '',
  email: '',
  personalEmail: '',
  phone: '',
  birthdate: undefined,
  nationality: undefined,
  role: undefined,
  isActive: false,
});
